import React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import { useFormProvider } from '../../../Providers/form'

const Title = () => {
  const { form } = useFormProvider()

  const { title } = form.values

  return <Text.Header1 weight="semibold">{title}</Text.Header1>
}

export default Title
